<!--  -->
<template>
  <div class='commodity-main'>
    <nav-title title="商品管理后台">
      <template v-slot:left>
        <span></span>
      </template>
    </nav-title>

    <main v-if="!show">
      <header>
        <div>
          <van-field v-model="search_name" placeholder="搜索商品名称" @keyup.enter.native="handleSearch">
            <template #right-icon>
              <van-icon name="search" @click="handleSearch"/>
            </template>
          </van-field>
        </div>
        <van-icon name="scan" size="30" color="#999" @click="handleScanPage"/>
      </header>

      <div class="sort-tabs" style="background: #fff;">
        <main>
          <div :class="{checked: sort == 1}" @click="handleSort('sort_zh', 1)">
            <span>{{zh_text}}</span>
            <van-icon name="play" class="icon" :class="{turn: sort_zh}"/>
          </div>
          <div :class="{checked: sort == 2}" @click="handleSort('sort_jg', 2)">
            <span>分类</span>
            <van-icon name="play" class="icon" :class="{turn: sort_jg}"/>
          </div>
          <div :class="{checked: sort == 3}" @click="handleSort('sort_pp', 3)">
            <span>品牌</span>
            <van-icon name="play" class="icon" :class="{turn: sort_pp}"/>
          </div>
        </main>
        <div :class="{checked: sort == 4}" @click="handleSort('all', 4)">
          <span>{{all_text}}</span>
          <van-icon name="play" class="icon" :class="{turn: all}"/>
        </div>
      </div>
      <main>
        <van-overlay :show="sort_zh || sort_pp || all" style="background: none;" @click="sort_zh = false;sort_pp = false;all=false"></van-overlay>
        <header class="sort-zh" v-if="sort_zh" @click="sort_zh = false">
          <div id="sort-zh">
            <div :class="{checked: order_type == 0}" @click="zh_text = '综合';handleZh(0)">综合</div>
            <div :class="{checked: order_type == 1}" @click="zh_text = '上架时间';handleZh(1)">上架时间</div>
            <div :class="{checked: order_type == 2}" @click="zh_text = '价格升序';handleZh(2)">价格升序</div>
            <div :class="{checked: order_type == 3}" @click="zh_text = '价格降序';handleZh(3)">价格降序</div>
          </div>
        </header>
        <header class="sort_pp" v-if="sort_pp" @click="sort_pp = false">
          <div id="sort_pp">
            <div :class="{checked: brand_id == item.brand_id}" v-for="(item, index) in brand_list" :key="index" @click="handleBrand(item.brand_id)">
              <span>{{ item.name }}</span>
            </div>
            <!-- <div @click.stop="pp_show = true"><span>全部品牌</span></div> -->
          </div>
        </header>
        <header class="sort-zh" v-if="all" @click="all = false">
          <div id="all">
            <div :class="{checked: is_direct == 0}" @click="all_text = '全部商品';handleAll(0)">全部商品</div>
            <div :class="{checked: is_direct == 1}" @click="all_text = '平台自营';handleAll(1)">平台自营</div>
            <div :class="{checked: is_direct == 2}" @click="all_text = '厂家直售';handleAll(2)">厂家直售</div>
          </div>
        </header>
        <div class="scroll-y">
          <van-list 
            offset="5"
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad">
            <div class="commodity-list">
              <div v-for="(item, index) in commodity_list" :key="index" class="commodity-item">
                <section>
                  <div class="tag" v-if="item.is_direct == 1">直营</div>
                  {{item.goods_name}}
                </section>
                <div>
                  <div>
                    <img :src="item.goods_img" alt="">
                  </div>
                  <main>
                    <div>
                      商品编码：{{item.goods_no}}
                    </div>
                    <div>
                      仓储位置：{{item.goods_address}}
                    </div>
                    <div>
                      库存：{{item.stock_num}}
                    </div>
                    <footer @click="handleDetails(item.goods_id)">详情</footer>
                  </main>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </main>
      <footer>
        <div class="footer-btn-red" @click="$router.push('/edit')">商品入库</div>
      </footer>
    </main>

    <van-popup 
      position="bottom"
      round 
      closeable
      v-model="sort_jg"
      style="border-radius: 12px 12px 0 0;">
      <div class="category_view">
        <header>
          全部筛选
        </header>
        <main>
          <aside>
            <div 
              v-for="(item, index) in category_list"
              :key="index"
              @click="category_idxs[0] = index;category_child = item.child"
              :class="{checked: index == category_idxs[0]}"
              :style="category_idxs[0]-1 == index ? 'border-radius: 0 0 8px 0;' : category_idxs[0]+1 == index ? 'border-radius: 0 8px 0 0;': ''">
              {{item.category_name}}
            </div>
            <div class="last" :style="category_idxs[0] == category_list.length - 1 ? 'border-radius: 0 8px 0 0;' : ''"></div>
          </aside>
          <main>
            <template v-if="$route.query.id">
              <div>
                <div v-for="(item, index) in category_child" :key="index" :class="{checked: item.category_id == category_id}" @click="category_id = item.category_id">{{item.category_name}}</div>
              </div>
            </template>
            <template v-else>
              <template v-for="(it, idx) in category_child">
                <nav :key="'n' + idx">{{it.category_name}}</nav>
                <div :key="'c' + idx">
                  <div v-for="(item, index) in it.child" :key="index" :class="{checked: item.category_id == category_id}" @click="category_id = item.category_id">
                    <span>{{item.category_name}}</span>
                  </div>
                </div>
              </template>
            </template>
          </main>
        </main>
        <footer>
          <div class="footer-btn" @click="category_id = 0;category_idxs = [0, 0, '']">重置</div>
          <div class="footer-btn-red" @click="handleConfirm">确定</div>
        </footer>
      </div>
    </van-popup>

    <van-popup 
      position="right"
      round 
      closeable
      close-icon="arrow-left"
      close-icon-position="top-left"
      v-model="pp_show"
      style="border-radius: 12px 0 0 12px;width: 300px;height: 100%;">
      <div class="pp-list">
        <header>品牌</header>
        <van-index-bar>
          <van-index-anchor index="A" />
          <van-cell title="文本" />
          <van-cell title="文本" />
          <van-cell title="文本" />
  
          <van-index-anchor index="B" />
          <van-cell title="文本" />
          <van-cell title="文本" />
          <van-cell title="文本" />
        </van-index-bar>
      </div>
    </van-popup>

    <scan-view ref="scan" v-if="show" @hide="show = false"></scan-view>
  </div>
</template>

<script>
import ScanView from '@/components/common/ScanView.vue'

export default {
  name: '',
  components: {
    ScanView
  },
  props: {},
  data () {
    return {
      id: '',
      search_name: '',
      sort: 1,
      height: '',
      AHeight: '',
      sort_zh: true,
      sort_jg: false,
      sort_pp: false,
      zh_text: '综合',
      order_type: 0,
      category_list: [],
      category_child: [],
      category_idxs: [],
      category_id: 0,
      brand_list: [],
      brand_id: 0,
      pp_show: false,
      all_text: '全部商品',
      is_direct: 0,
      all: true,
      loading: false,
      finished: false,
      page: 1,
      commodity_list: [],
      show: false
    }
  },
  computed: {},
  watch: {
    sort_zh () {
      if (this.sort_zh) {
        this.$nextTick(() => {
          document.getElementById('sort-zh').style.height = '0px'
          setTimeout(() => {
            document.getElementById('sort-zh').style.height = this.height + 'px'
          }, 100);
        })
      }
    },
    all () {
      if (this.all) {
        this.$nextTick(() => {
          document.getElementById('all').style.height = '0px'
          setTimeout(() => {
            document.getElementById('all').style.height = this.AHeight + 'px'
          }, 100);
        })
      }
    }
  },
  created () {
    this.getBrandList()
  },
  mounted () {
    this.$nextTick(() => {
      this.height = document.getElementById('sort-zh').offsetHeight
      this.sort_zh = false
      this.AHeight = document.getElementById('all').offsetHeight
      this.all = false
    })
  },
  activated () {
    let previousRoute = window.localStorage.getItem('previousRoute')
    if (previousRoute != '/commodity/details') {
      this.id = this.$route.query.id || ''
      this.category_id = this.id || 0
      this.search_name = this.$route.query.search_name || ''
      this.sort_jg = false
      this.sort_pp = false
      this.sort = 1
      this.zh_text = '综合'
      this.order_type = 0
      this.category_list = [],
      this.category_child = []
      this.category_idxs = []
      this.brand_id = 0
      this.pp_show = false
      this.all_text = '全部商品'
      this.is_direct = 0
      this.commodity_list = []
      this.page = 1
      this.loading = false
      this.finished = false
      this.getCategory()
      this.getList()
    }
  },
  deactivated () {
    this.sort_zh = false
    this.sort_jg = false
    this.sort_pp = false
  },
  methods: {
    // 扫码
    handleScanPage () {
      this.show = true
      this.$nextTick(() => {
        this.$refs.scan.init((url) => {
          let goods_id = ''
          if (url.indexOf('goods_id=') != -1) {
            goods_id = url.split('goods_id=')[1]
            this.$router.push('/details?goods_id=' + goods_id)
          } else {
            this.$toast.fail('二维码无法识别')
            return
          }
        })
      })
    },
    // 搜素
    handleSearch () {
      if (this.search_name) {
        this.$http({
          method: 'post',
          data: {
            c: 'search/add',
            search_name: this.search_name
          }
        })
      }
      this.onRefresh()
    },
    // 商品
    // ···下拉刷新
    onRefresh() {
      this.commodity_list = []
      this.page = 1
      this.finished = false
      this.getList()
    },
    // ···上拉加载
    onLoad() {
      this.getList()
    },
    // ···列表获取
    getList () {
      this.loading = true;
      this.$http({
        method: 'post',
        data: {
          c: 'goods/goods_list',
          page: this.page,
          page_size: 10,
          category_id: this.id || 0,
          search_name: this.search_name,
          order_type: this.order_type,
          brand_id: this.brand_id,
          is_direct: this.is_direct
        }
      }).then(res => {
        this.loading = false
        if (res.code == 200) {
          let list = res.data.list
          this.commodity_list = this.commodity_list.concat(list)
          if (list.length == 10) {
            this.page++
          } else {
            this.finished = true
          }
        } else {
          this.finished = true
          this.$toast.fail(res.message || '商品数据获取失败')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 跳转详情
    handleDetails (id) {
      this.$router.push({
        path: '/details?goods_id=' + id
      })
    },
    // 显示筛选
    handleSort (key, sort) {
      this.sort_zh = false
      this.sort_jg = false
      this.sort_pp = false
      this.all = false
      this.$nextTick(() => {
        this[key] = true
        this.sort = sort
      })
    },
    // 综合筛选
    handleZh (type) {
      this.order_type = type
      this.onRefresh()
    },
    // 获取分类数据
    getCategory () {
      this.$http({
        method: 'post',
        data: {
          c: 'goods/category_list',
          category_id: this.$route.query.id || 0
        }
      }).then(res => {
        if (res.code == 200) {
          this.category_list = res.data
          this.category_idxs = [0, '', '']
          this.category_child = this.category_list[0].child

          this.category_list.forEach((item, index) => {
            item.child.forEach((it, idx) => {
              if (this.$route.query.id) {
                if (this.$route.query.id == it.category_id) {
                  this.category_idxs = [index, idx]
                  this.category_child = item.child
                }
              }
            })
          })
        } else {
          this.$toast.fail(res.message || '分类数据获取失败')
        }
      })
    },
    // 选择分类
    handleConfirm () {
      this.sort_jg = false
      this.id = this.category_id
      this.onRefresh()
    },
    // 获取品牌
    getBrandList () {
      this.$http({
        method: 'post',
        data: {
          c: 'goods/brands'
        }
      }).then(res => {
        if (res.code == 200) {
          this.brand_list = res.data
        } else {
          this.$toast.fail(res.message || '品牌数据获取失败')
        }
      })
    },
    // 选择品牌
    handleBrand (id) {
      if (this.brand_id != id) {
        this.brand_id = id
      } else {
        this.brand_id = 0
        this.sort = 0
      }
      this.onRefresh()
    },
    // 选择是否自营
    handleAll (type) {
      this.is_direct = type
      this.onRefresh()
    }
  }
}

</script>

<style lang='less' scoped>
.commodity-main {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  > main {
    width: 100%;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    > header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      margin: 0 10px 0;
      padding-right: 5px;
      > div {
        flex: 1;
        margin-right: 15px;
        > .van-cell {
          padding: 8px 12px;
          font-size: 15px;
          border-radius: 34px;
          height: 34px;
          border: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
        }
      } 
    }
    > .sort-tabs {
      padding: 10px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > main {
        flex: 1;
        display: flex;
        align-items: center;
        > div {
          flex: 1;
          display: flex;
          align-items: center;
          color: #262626;
          leading-trim: both;
          text-edge: cap;
          font-family: "PingFang SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          letter-spacing: -0.408px;
          > .icon {
            transform: rotateZ(90deg);
            margin-left: 3px;
          }
          > .turn {
            transform: rotateZ(-90deg);
          }
        }
        .checked {
          color: #E73F22;
        }
      }
      > div {
        width: 117px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 1px solid #CBCFD2;
        color: #262626;
        leading-trim: both;
        text-edge: cap;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.408px;
        > .icon {
          transform: rotateZ(90deg);
          margin-left: 3px;
        }
        > .turn {
          transform: rotateZ(-90deg);
        }
      }
      > .checked {
        color: #E73F22;
      }
    }
    > .tabs {
      padding: 0 15px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      > div {
        width: 80px;
        height: 28px;
        border-radius: 4px;
        background: #F3F4F8;
        display: flex;
        align-items: center;
        justify-content: center;
        > .icon {
          transform: rotateZ(90deg);
          margin-left: 3px;
          color: #9B9E9D;
        }
      }
      .checked {
        color: #E73F22;
        > .icon {
          color: #E73F22;
        }
      }
    }

    > main {
      flex: 1;
      padding: 20px 15px 0;
      overflow: hidden;
      background: #FAFAFA;
      flex-shrink: 0;
      position: relative;
      > .all,
      > .sort-zh {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0;
        background: rgba(0, 0, 0, 0.40);
        z-index: 99;
        > div {
          width: 100%;
          padding: 0 15px;
          border-radius: 0 0 12px 12px;
          background-color: #fff;
          transition: all 0.3s linear;
          overflow: hidden;
          > div {
            padding: 14px 0 17px;
            border-bottom: 1px solid #F3F4F6;
            color: #000;
            text-align: left;
            leading-trim: both;
            text-edge: cap;
            font-family: "PingFang SC";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            letter-spacing: -0.408px;
          }
          > .checked {
            color: #E73F22;
          }
        }
      }
      > .sort_pp {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0;
        background: rgba(0, 0, 0, 0.40);
        z-index: 99;
        > div {
          width: 100%;
          max-height: 336px;
          padding: 14px;
          border-radius: 0 0 12px 12px;
          background-color: #fff;
          overflow: hidden;
          overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          gap: 9px;
          -ms-overflow-style: none;  /* IE 和 Edge */
          scrollbar-width: none;  /* Firefox */
          scrollbar-height: none;
          &::-webkit-scrollbar {
            width: 0;
            height: 0;
          }
          > div {
            width: 80px;
            // height: 36px;
            // line-height: 36px;
            text-align: center;
            flex-shrink: 0;
            border-radius: 4px;
            background: #F3F4F6;
            color: #000000;
            leading-trim: both;
            text-edge: cap;
            font-family: "PingFang SC";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            letter-spacing: -0.408px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
          }
          > .checked {
            color: #E73F22;
            background: rgba(231, 63, 34, 0.10);
          }
        }
      }
      > div {
        height: 100%;
        overflow-y: scroll;
        flex-shrink: 0;
        .commodity-list {
          width: 100%;
          flex-shrink: 0;
          .commodity-item {
            flex-shrink: 0;
            border-radius: 4px;
            background: #FFF;
            overflow: hidden;
            margin-bottom: 10px;
            padding: 10px 15px;
            > section {
              color: #161616;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              font-family: "PingFang SC";
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              letter-spacing: -0.408px;
              > div {
                display: inline-block;
                vertical-align: bottom;
                width: 32px;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                text-align: center;
                margin-right: 2px;
                border-radius: 2px;
                color: #361B00;
                background: linear-gradient(133deg, #F5E5AD 17.1%, #F5CB44 82.9%);
                font-family: FZZhengHeiS-M-GB;
              }
            }
            > div {
              display: flex;
              margin-top: 10px;
              > div {
                width: 64px;
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                > img {
                  max-width: 64px;
                  max-height: 64px;
                  margin-right: 10px;
                }
              }
              > main {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                flex-shrink: 0;
                position: relative;
                > div {
                  width: 100%;
                  color: #9F9DA8;
                }
                > footer {
                  width: 60px;
                  height: 28px;
                  line-height: 28px;
                  text-align: center;
                  border-radius: 4px;
                  color: #E73F22;
                  background: rgba(231, 63, 34, 0.10);
                  font-family: "PingFang SC";
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 400;
                  letter-spacing: -0.408px;
                  position: absolute;
                  right: 0;
                  bottom: 0;
                }
              }
            }
          }
        }
      }
    }

    > footer {
      padding: 10px 15px;
      display: flex;
      align-items: center;
      > div {
        width: 100%;
      }
    }
  } 
}

.category_view {
  width: 375px;
  height: 534px;
  flex-shrink: 0;
  border-radius: 12px 12px 0 0;
  background: #FFF;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  > header {
    padding: 20px 0 0;
    text-align: center;
    color: #000;
    leading-trim: both;
    text-edge: cap;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.408px;
    margin-bottom: 25px;
  }
  > main {
    flex: 1;
    display: flex;
    overflow: hidden;
    > aside {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      > div {
        background-color: #F3F4F6;
        padding: 15px 20px;
        color: #262626;
        text-align: right;
        leading-trim: both;
        text-edge: cap;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.408px;
      }
      > div.last {
        padding: 0;
        flex: 1;
        background-color: #F3F4F6;
      }
      > .checked {
        background-color: #fff;
      }
    }
    > main {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 14px 20px;
      > nav {
        color: #000;
        leading-trim: both;
        text-edge: cap;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.408px;
        padding: 14px 0;
      }
      > div {
        margin-bottom: 6px;
        display: flex;
        flex-wrap: wrap;
        gap: 7px;
        > div {
          width: 110px;
          min-height: 40px;
          flex-shrink: 0;
          border-radius: 4px;
          background: #F3F4F6;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
          text-align: center;
        }
        > div.checked {
          color: #E73F22;
          background: rgba(231, 63, 34, 0.10);
        }
      }
    }
  }
  > footer {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0 20px;
    > div {
      flex: 1;
    }
  }
}
.pp-list {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  > header {
    padding: 15px;
    text-align: center;
    color: #000;
    leading-trim: both;
    text-edge: cap;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.408px;
  }
  /deep/ .van-index-anchor {
    line-height: 0px;
    padding: 14px 0 14px;
    border-bottom: 1px solid #F3F4F6;
    margin: 6px 0 14px;
  }
  /deep/ .van-cell {
    line-height: 28px;
  }
  /deep/ .van-index-bar__sidebar {
    width: 18px;
    border-radius: 7px;
    background: #F0F0F0;
    padding: 8px 2px;
    .van-index-bar__index {
      padding: 0;
      color: #979797;
      leading-trim: both;
      text-edge: cap;
      font-family: "PingFang SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.408px;
      margin-bottom: 3px;
    }
  }
}
</style>
